import axios from 'axios'

export const getCategories = ({ commit }) => {
  commit('setLoading', true);
  axios.get('/api/categories/getCategories')
    .then(response => {
      commit('getCategories', response.data.data)
    })
    // fail
    .catch(e => {
      commit('getCategories', e.response)
    })
    .finally(() => {
      commit('setLoading', false);
    });
}